var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.79 11.942a.625.625 0 0 1-.884 0L3.478 8.513a.625.625 0 0 1-.08-.785l.08-.099 3.428-3.428a.626.626 0 0 1 .884.884L5.428 7.447H12.3a.625.625 0 0 1 0 1.25H5.43l2.36 2.361a.625.625 0 0 1 0 .884"
  })));
};
export default SvgArrowLeft;